export function toJsonMarkdown(jsonContent: string): string {
  return `\`\`\`json\n${jsonContent}\n\`\`\``;
}

export function toYamlMarkdown(yamlContent: string): string {
  return `\`\`\`yaml\n${yamlContent}\n\`\`\``;
}
